import { Injectable } from '@angular/core';
import { jkRestReturn, idNameItem, entityState } from 'jk-service';
import {
  EntityType,
  JkEntityV2,
  jkLib,
  dateFormatter,
  AgComboBoxEditor,
} from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Mtrwb } from '../_entity_mtr';
import { MtrwbServicePkg } from './mtrwbPkg.service';

@Injectable({
  providedIn: 'root',
})
export class MtrwbService extends MtrwbServicePkg {
  isAdmin: boolean = false;
  adminUsers: string = 'JACKIE,JACK,ADMIN';
  constructor() {
    super();
            //this.MtrWb006List.push(...tmpList);
    //  客戶基本資料加上 部門單身
    this.orm.doOpenWin_get('S', 'MTRMM', 'S01', [this.login.CUSTOMER]).subscribe({
      next: (res: jkRestReturn) => {
        if (!res.result) {
          alert('錯誤: MTRMM-S01 ' + res.message);
          return;
        }
        this.MtrWb006List = res.obj as idNameItem[];
      }
    });
    this.orm.doOpenWin_get('S', 'MTRMC', 'S01', []).subscribe({
      next: (res: jkRestReturn) => {
        if (!res.result) {
          alert('錯誤: MTRMC-S01 ' + res.message);
          return;
        }
        const list = res.obj as idNameItem[];
        if (!list) return;
      }
    });

    this.orm.doOpenWin_get('S', 'MTRMC', 'S01', []).subscribe({
      next: (res: jkRestReturn) => {
        if (!res.result) {
          alert('錯誤: MTRMC-S01 ' + res.message);
          return;
        }
        const list = res.obj as idNameItem[];
        if (!list) return;
        let tmpList =
          list.filter((item: idNameItem) => item.ps1?.startsWith('1')) || [];
        //this.MtrWb006List.push(...tmpList);
        tmpList = list.filter((item: idNameItem) => item.ps1?.startsWith('4'));
        this.MtrWb007List.push(...tmpList);
        tmpList = list.filter((item: idNameItem) => item.ps1?.startsWith('3'));
        this.MtrWb013List.push(...tmpList);
        this.cdr?.detectChanges(); // zoneless: list 更新後觸發 CD（? 保護 constructor 時 cdr 尚未注入的情況）
      },
      error: (err: any) => {
        alert('錯誤: MTRMC-S01 ' + err.message);
      },
      complete: () => {},
    });
    this.sqlSelect = `SELECT TOP 1000 MTRWB.*  FROM MTRWB
    `;
    if (this.adminUsers.includes(this.userId.toUpperCase() + ',')) {
      this.isAdmin = true;
      this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    } else {
      this.isAdmin = false;
      this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1 AND WB024 = '${this.login.CUSTOMER}'`; // this.userId
    }
    this.sqlOrderDefault = ` ORDER BY WB004 DESC,WB002 DESC`;
  }
  setOrder(s: string) {
    switch (s) {
      case '1':
        this.sqlOrder =
          ' ORDER BY MTRWB.WB014, MTRWB.WB012,MTRWB.WB008,MTRWB.WB009 '; // 結案碼+處理順序+序號+程式代號+程式名稱
        break;
      case '2':
        this.sqlOrder =
          ' ORDER BY MTRWB.WB014,MTRWB.WB015 ,MTRWB.WB012,MTRWB.WB008,MTRWB.WB009 '; // 結案碼+預計完工日+處理順序+程式代號+程式名稱
        break;
      case '3':
        this.sqlOrder =
          ' ORDER BY MTRWB.WB014,MTRWB.WB004 DESC,MTRWB.WB015 DESC,MTRWB.WB012,MTRWB.WB008,MTRWB.WB009 '; // 結案碼+單據日期(-)+預計完工日(-)+處理順序+程式代號+程式名稱
        break;
      default:
        this.sqlOrder = ' ORDER BY MTRWB.WB001,MTRWB.WB002 '; // 單號
    }
  }
  override async newRecord(newItem: Mtrwb): Promise<Mtrwb> {
    await super.newRecord(newItem);
    this.item = newItem;
    newItem.WB001 = 'MT01';
    newItem.WB004 = this.nowDate();
    newItem.WB002 = ''; // await this.billNo(newItem.WB001, newItem.WB004); // TODO: await 改 rxjs
    newItem.WB003 = this.userId;
    await this.WB003Change(newItem, newItem.WB003);
    newItem.WB005 = this.login.name;
    newItem.WB016 = this.login.EMAIL;
    newItem.WB024 = this.login.CUSTOMER;

    newItem.WB014 = 'N'; // 結案碼
    newItem.WB012 = '3'; // 處理順序
    newItem.WB013 = '等程式';
    await this.WB004Change(newItem, newItem.WB004);
    this.cdr.detectChanges();
    return newItem;
  }
  async WB003Change(item: Mtrwb, value: string): Promise<void> {
    //this.cdr.markForCheck();
    if (!item || !item.WB003) return;
    await this.orm.advCheck(
      item,
      'SYSUser',
      'V01',
      'WB005,WB016,WB024',
      [value],
      'E',
      this.login.host,
    );
    /*setTimeout(() => {
      this.cdr.detectChanges();
    });*/

    /*
    this.orm
      .doOpenWin(this.login.hostName, 'V', 'SYSUser', 'V01', '', '', item.WB003)
      .subscribe({
        next: (ret: jkRestReturn) => {
          if (!ret.result) {
            alert('錯誤: 查詢反應者代號失敗 ' + (ret.message || ''));
            return;
          }
          setTimeout(() => {
            this.orm.advCheckParse(
              item,
              'SYSUser',
              'V01',
              'WB005,WB016,WB024',
              ret,
            );
            if (!ret.result) {
              alert('錯誤: 解析反應者代號失敗 ' + (ret.message || ''));
            }
            this.cdr.detectChanges();
          });
        },
        error: (err: any) => {
          alert('錯誤: 無法連線後端資料庫或查詢失敗 ' + (err.message || ''));
          setTimeout(() => {
            this.cdr.detectChanges();
          });
        },
      });*/
  }
  async WB004Change(item: Mtrwb, value: any) {
    // 單據日期
    // TODO: check date
    if (this.state === entityState.dsInsert) {
      item.WB002 = await this.billNo(item.WB001, value); // item.WB004
      /*setTimeout(() => {
        this.cdr.detectChanges();
      });*/
      this.cdr.markForCheck();
    }
  }
  /*
  doHelp(programId:string): void {
    // var w = window.open('http://goo.gl/suO2gK', '_blank', 'menubar=no,status=no,scrollbars=no,top=0,left=0,toolbar=no');
    //http://localhost:4200/helpviewer?SH001=002&SH013=PACKAGE
    const url = this.login.host + '/sys/helpviewer?SH001=' + programId;// + '&SH013=' + this.login.userid;
    const w = window.open(
      url,
      '_blank',
      'menubar=no,status=no,scrollbars=no,top=0,left=0,toolbar=no',
    );
  }*/
  // 上傳附件
  doUpload(item: Mtrwb) {
    //var urlUpload = 'http://www.jack168.com/upload/default.aspx'; // ?path=//nas5/Public/附件區/" + jkGlb.User.dbname() + "/YYYYMM/工作日報/W102-" + TD002;
    var urlUpload = 'https://www.jack168.com/upload/default.aspx'; // http 會被標記不安全
    // DBNAME/工作日報/年月/單別-單號
    if (!this.item) {
      alert('請先選單號!!!');
    } else {
      // urlUpload = urlUpload + "?path=C:/rd/附件區/" + jkGlb.User.dbname + "/" + myTable.getField("CREATE_DATE").substring(0, 6) + "/" + myTable.billType() + "-" + myTable.billNo();
      urlUpload =
        urlUpload +
        '?path=D:/附件區/' +
        this.login.dbname +
        '/' +
        this.item.CREATE_DATE.substring(0, 6) +
        '/' +
        item.WB001 +
        '-' +
        item.WB002;
      //this.router.navigate({ view: 'upload', id: urlUpload }); // billNo
      // 用 jkupload.component.ts 的方式
    }
  }
  billno(item: Mtrwb): string {
    return item.WB001 + '-' + item.WB002;
  }
  doMail(item: Mtrwb): void {
    if (this.isEmpty(item) || this.isEmpty(item.WB001)) {
      alert('請先選單號!!!');
      return;
    }
    const param = '/mtr/supportmail?key1=' + item.WB001 + '&key2=' + item.WB002;
    this.ret.clear;
    const url = this.login.host + param;
    this.orm.http.get(url).subscribe({
      next: (v: any) => {
        this.ret = v;
        if (this.ret.result) {
          alert('完成!單號:' + this.billno(item) + '送出郵件');
        } else {
          alert(
            'XXX 錯誤!單號:' +
              this.billno(item) +
              ' ' +
              this.ret.errorLog +
              ' 送出郵件',
          );
        }
        this.cdr.detectChanges(); // zoneless: HTTP 回呼後觸發 CD
      },
    });
  }
  async WB024Change(value: any) {
    // 客戶代號
    let bool = await this.advCheck(
      'WB024',
      this.item,
      'COPMA',
      'V01',
      'MA002',
      [value],
      'E',
      '客戶代號錯誤.',
    );
    setTimeout(() => {
      this.cdr.detectChanges(); // zoneless: await 後觸發 CD
    });
  }
}

